import React, { useEffect, useState } from 'react';
import { Button, FlexDirectionRow, MainContent, SubTitle } from "../../../../../components/StyledComponents";
import { Grid } from "@mui/material";
import { valueIsRequired } from "../../../../../utils/regex";
import { useApp } from "../../../../../context/app";
import { useForm } from "react-hook-form";
import Spinner from "react-spinner-material";
import { handleModalStatus } from "../../../../../utils/handleModalStatus";
import { BaSeDialogContext } from "@base/react";
import Input from "../../../../../components/InputControlled";
import { DevolutivaPadraoService } from "../../../services/devolutivaPadraoService";
import EditorTextControlled from "../../../../../components/EditorTextControlled";

export const Editar = () => {
    
    const {showModal} = React.useContext(BaSeDialogContext);
    const {setRenderIncludeScreen, manageItem} = useApp();
    const {control, handleSubmit, reset} = useForm({
        defaultValues: {
            motivo: '',
            descricao: '',
            basico: '',
            intermediario: '',
            avancado: '',
        }
    });
    const [isSubmited, setIsSubmited] = useState(false);
    
    
    useEffect(() => {
        const resetData = async () => {
            const {data} = manageItem;
            const response = await findDevolutiva(data?.id)
            if (response) {
                reset(response);
            }
        }
        resetData()
        // https://github.com/facebook/create-react-app/issues/6880
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [manageItem]);
    
    
    const onResetFields = () => {
        reset();
    }
    
    const submitForm = async (dataForm) => {
        setIsSubmited(true);
        if (dataForm.id) {
            await editItem(dataForm);
            return;
        }
        // await createItem(dataForm);
    }
    
    const findDevolutiva = async (id) => {
        return await DevolutivaPadraoService.find(id)
    };
    
    const handleGoHome = () => {
        setRenderIncludeScreen(false);
    };
    
    
    const editItem = async (dataForm) => {
        DevolutivaPadraoService.update(dataForm)
            .then(() => {
                handleModalStatus({
                    type: "success",
                    msgOnSuccess: "A devolutiva padrão foi atualizada com sucesso.",
                    onCloseModal: handleGoHome,
                    showModal,
                });
            })
            .catch((error) => {
                handleModalStatus({
                    type: "error",
                    msgOnError:
                        error?.response?.data?.message ??
                        "A devolutiva padrão não foi atualizada. Aconteceu um erro ou o sistema está temporariamente fora do ar. Tente novamente mais tarde.",
                    showModal,
                })
            })
            .finally(() => {
                setIsSubmited(false);
            })
    }
    
    const handleLabelLevel = (nome) => {
        const letter = nome.charAt(0);
        const COLOR_OPTION = {
            'B': '#CD5BE8',
            'I': '#666BFD',
            'A': '#0DBABA'
        }
        
        return (
            <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: '8px'}}>
                <div style={{
                    backgroundColor: '#FFFFF',
                    borderRadius: '32px',
                    width: '32px',
                    height: '32px',
                    display: "flex",
                    justifyContent: "center",
                    alignContent: "center",
                    alignItems: "center",
                    fontWeight: "bold",
                    color: COLOR_OPTION[letter],
                    boxShadow: "2px 2px 4px rgba(84, 90, 174, 0.15)",
                    marginRight: "8px"
                }}>
                    {letter}
                </div>
                {nome}
            </div>
        
        )
    }
    
    return (
        <>
            <MainContent>
                <SubTitle>
                    <h3>{manageItem?.data?.id ? "Editar" : "Incluir"}</h3>
                </SubTitle>
                
                <Grid
                    container
                    item
                    flexDirection={'columm'}
                >
                    <Grid item md={7}>
                        <Input
                            name="descricao"
                            control={control}
                            rules={{...valueIsRequired()}}
                            placeholder="Descrição"
                            showMaxLengthLabel={false}
                            maxLength={120}
                        />
                    
                    </Grid>
                </Grid>
    
                <Grid
                    container
                    item
                    flexDirection={'columm'}
                    mb={4}
                >
                    <p>Descrição <span style={{fontWeight: 'bold', color: '#0061C6'}}>*</span></p>
                </Grid>
                
                <Grid
                    container
                    item
                    flexDirection={'columm'}
                >
                  
                    <Grid item md={7}>
                        <EditorTextControlled
                            notRequired={true}
                            disabled={false}
                            name="basico"
                            control={control}
                            rules={{...valueIsRequired()}}
                            label={handleLabelLevel('Básico')}
                            placeholder={'Básico'}
                            showMaxLengthLabel={true}
                            maxLength={2000}
                        />
                    </Grid>
                
                </Grid>
                
                <Grid
                    container
                    item
                    flexDirection={'columm'}
                >
                    <Grid item md={7}>
                        <EditorTextControlled
                            notRequired={true}
                            disabled={false}
                            name="intermediario"
                            control={control}
                            rules={{...valueIsRequired()}}
                            label={handleLabelLevel('Intermediário')}
                            placeholder={'Intermediário'}
                            showMaxLengthLabel={true}
                            maxLength={2000}
                        />
                    </Grid>
                
                </Grid>
                
                <Grid
                    container
                    item
                    flexDirection={'columm'}
                >
                    <Grid item md={7}>
                        <EditorTextControlled
                            notRequired={true}
                            disabled={false}
                            name="avancado"
                            control={control}
                            rules={{...valueIsRequired()}}
                            label={handleLabelLevel('Avançado')}
                            placeholder={'Avançado'}
                            showMaxLengthLabel={true}
                            maxLength={2000}
                        />
                    </Grid>
                
                </Grid>
                
                
                <Grid container justifyContent="flex-end">
                    <Grid item>
                        <FlexDirectionRow position={"end"}>
                            {
                                !manageItem?.data?.id &&
                                <Button
                                    href="#"
                                    backgroundColor={"#9CA2A8"}
                                    onClick={onResetFields}
                                >
                                    Limpar
                                </Button>
                            }
                            
                            <div style={{marginLeft: "10px", marginRight: "10px"}}/>
                            <Button
                                href="#"
                                disabled={isSubmited}
                                onClick={handleSubmit(submitForm)}
                            >
                                {isSubmited ? (
                                    <Spinner radius={16} color={"#fff"} stroke={2} visible={true}/>
                                ) : (
                                    manageItem?.data?.id ? "Editar" : "Incluir"
                                )}
                            </Button>
                        </FlexDirectionRow>
                    </Grid>
                </Grid>
            </MainContent>
        </>
    )
}
